import Segment from './segment';
import { APIErrorType } from '../../api';

export type ErrorProps = {
  errorMessage?: string;
  error?: APIErrorType;
};

export const DEFAULT_ERROR_MESSAGE = 'خطایی رخ داده است.';

function Error({ errorMessage = DEFAULT_ERROR_MESSAGE, error }: ErrorProps) {
  return (
    <Segment color='red' dataTestId='error' textAlign='center'>
      <p className='my-3 font-medium text-red-500'>{errorMessage}</p>
      {error?.status && (
        <p className='my-3'>
          <span>کد خطا: </span>
          <span>{error.status}</span>
        </p>
      )}
      {error?.data && <p className='my-4'>{JSON.stringify(error.data)}</p>}
    </Segment>
  );
}

export default Error;
